import { DomainsDescription } from '@models/feature-descriptor-domain';
import { DescriptionsTree } from '../models';

const isNotEmpty = (arr: any[]) => arr.length > 0;

export function filterDomainsDescriptionsTree(
  domains: DescriptionsTree,
  predicateFn: (
    domainDescription: DomainsDescription & { nodeId: DescriptionsTree.NodeId }
  ) => boolean
): DescriptionsTree {
  return {
    types: domains.types
      .map(({ summary, columns, nodeId }) => ({
        summary,
        nodeId,
        columns: columns
          .map(column => ({
            summary: column.summary,
            nodeId: column.nodeId,
            descriptions: column.descriptions.filter(predicateFn),
          }))
          .filter(({ descriptions }) => isNotEmpty(descriptions)),
      }))
      .filter(({ columns }) => isNotEmpty(columns)),
  };
}
